
































import { Component, Vue, Watch } from "vue-property-decorator";
import FormField from "@/layouts/DashboardLayoutComponents/FormField.vue";

import permissionModel from "@/models/permission.model";

@Component({ components: { FormField } })
export default class DashboardSettings extends Vue {
	permissionSchema: any[] = [];

	selectionEntity: any = { userRole: null };

	dashboardModules: any[] = [];

	async mounted() {
		this.permissionSchema = await permissionModel.getDescription();
	}

	@Watch('selectionEntity', { deep: true })
	async userRoleChanged(entity: any) {
		this.dashboardModules = [];
		if (entity.userRole) {
			await this.reloadPaths();
		}
	}

	async reloadPaths() {
		const permissions = await permissionModel.search({ search: { userRole: this.selectionEntity.userRole } });
		const dashboardModules = this.permissionSchema.find(field => field.key === "dashboardModule")?.options?.map((option: any) => ({ ...option }));
		dashboardModules?.forEach((option: any) => {
			option.permission = permissions.find((permission: any) => permission.dashboardModule === option.value);
			option.hasPermission = !!option.permission;
		});
		this.dashboardModules = dashboardModules;
	}

	async togglePermission(hasPermission: any, dashboardModule: any) {
		try {
			if (hasPermission) {
				await permissionModel.create({ userRole: this.selectionEntity.userRole, dashboardModule: dashboardModule.value, permissionType: 'READ' });
			} else {
				await permissionModel.delete(dashboardModule.permission.id);
			}
			await this.reloadPaths();
			this.$toasted.success('Permissão alterada com sucesso');
		} catch (error) {
			console.error(error);
			this.$toasted.error('Não foi possível alterar a permissão. Tente novamente.');
			dashboardModule.hasPermission = !hasPermission; // undo change
		}
	}

	async setPermissionType(dashboardModule: any, permissionType: string) {
		try {
			if (this.$route.meta.permissionType === 'READ_WRITE' && dashboardModule.permission) {
				await permissionModel.update(dashboardModule.permission.id, { ...dashboardModule.permission, permissionType });
				await this.reloadPaths();
				this.$toasted.success('Permissão alterada com sucesso');
			}
		} catch (error) {
			console.error(error);
			this.$toasted.error('Não foi possível alterar a permissão. Tente novamente.');
		}
	}
}
